import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import {
  GetManyResponse,
  IAddressAutocomplete,
  ICountryAutocomplete,
  IRequestPayload,
  IStateAcutocomplete,
} from 'coreOld/types';
import { getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';

export const getManyAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IAddressAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/addresses/address/autocomplete?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<IAddressAutocomplete>(data.addresses, data.total_count);
};

export const getCountriesAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICountryAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/addresses/country/autocomplete?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<ICountryAutocomplete>(data.countries, data.total_count);
};

export const getStatesAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IStateAcutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/addresses/state/autocomplete?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<IStateAcutocomplete>(data.states, data.total_count);
};
